import { useLayoutEffect, useState } from "react";

const useElementWidth = (ref: React.RefObject<HTMLElement>) => {
	const [width, setWidth] = useState(0);
	useLayoutEffect(() => {
		const element = ref.current;

		if (!element) return;

		const updateWidth = () => {
			setWidth(element.getBoundingClientRect().width);
		};

		updateWidth();

		const resizeObserver = new ResizeObserver(updateWidth);
		resizeObserver.observe(element);

		return () => {
			resizeObserver.disconnect();
		};
	}, [ref.current]); // вот ключевой момент

	return width;
};

export default useElementWidth;
